jQuery(document).ready(function(){
    
    //Moble Menu Script
    jQuery(".mobilemenuicon").click(function(){
        jQuery('.mobilemenuicon .icon-bar').toggleClass('active');
        jQuery("body").toggleClass("mobile-menu-open");
    });
    jQuery(".menu-open-overlay").click(function(){
        jQuery(".mobilemenuicon .icon-bar").removeClass('active');
        jQuery("body").removeClass("mobile-menu-open");
    });

    jQuery(".slick-prev.slick-arrow").attr( "title", "Previous" );
    jQuery(".slick-next.slick-arrow").attr( "title", "Next" );

    //Home Banner Slider
    jQuery('.hero-slider').slick({
      arrows: false,
      dots: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      fade: true,
      speed: 500,
      autoplay: true,
      autoplaySpeed: 5000,
      cssEase: 'ease-in-out',
      pauseOnHover: false,
      pauseOnFocus: false,
      swipe: true,
      touchMove: true,
      waitForAnimate: false,
    });

    //Brands Slider
    jQuery('.brands-slider').slick({
        infinite: true,
        dots: false,
        arrows: false,
        autoplay: true,
        speed: 1000,
        slidesToShow: 5,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1
                }
            }
        ]
    });

    //Services Slider
    jQuery('.service-slider').slick({
        infinite: true,
        dots: false,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 600,
        slidesToShow: 3,
        slidesToScroll: 1,
        swipeToSlide: true,
        touchThreshold: 10,
        centerMode: true,
        centerPadding: '180px',
        cssEase: 'cubic-bezier(0.45, 0, 0.55, 1)',
        useTransform: true,
        useCSS: true,
        waitForAnimate: false,
        pauseOnHover: false,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    centerMode: true,
                    centerPadding: '80px',
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    centerPadding: '60px',
                }
            }
        ]
    });

    //Testimonials Slider
    jQuery('.testim-slider').slick({
        infinite: true,
        dots: true,
        arrows: false,
        autoplay: true,
        speed: 1000,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 991,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
    

});//End

document.addEventListener("DOMContentLoaded", function () {
    let wishlistBtns = document.querySelectorAll(".wishlist-btn");

    function updateWishlistUI() {
        let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
        wishlistBtns.forEach(btn => {
            let productHandle = btn.getAttribute("data-product-handle");
            if (wishlist.includes(productHandle)) {
                btn.classList.add("active");
                btn.innerHTML = "Heart Fill"; // Active state icon
            } else {
                btn.classList.remove("active");
                btn.innerHTML = "Heart"; // Default state icon
            }
        });
    }

    wishlistBtns.forEach(btn => {
        btn.addEventListener("click", function () {
            let productHandle = this.getAttribute("data-product-handle");
            let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

            if (wishlist.includes(productHandle)) {
                wishlist = wishlist.filter(handle => handle !== productHandle);
            } else {
                wishlist.push(productHandle);
            }

            localStorage.setItem("wishlist", JSON.stringify(wishlist));
            updateWishlistUI();
        });
    });

    // Initialize wishlist UI
    updateWishlistUI();
});

